import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import React from 'react';

const Bullets = ({ items }) => (
  <List dense disablePadding sx={{ mb: 2 }}>
    {items.map((text, i) => (
      <ListItem key={i} alignItems="flex-start" sx={{ py: 0.5, pl: 0 }}>
        <ListItemText
          primary={<Typography variant="subtitle1">• {text}</Typography>}
        />
      </ListItem>
    ))}
  </List>
);

export default function SICInfoDialog({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: { xs: '100%', sm: '90%', md: '1200px' },
          mx: { xs: 1, sm: 2, md: 'auto' },
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 700, fontSize: { xs: '1rem', sm: '1.15rem' }, textAlign: 'center' }}>
        Samsung Innovation Campus (SIC) 2026 – Participant Guidelines
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
          Welcome to Samsung Innovation Campus 2026
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          Samsung Innovation Campus (SIC) is Samsung's flagship Corporate Social Responsibility (CSR) programme designed to equip young learners with industry-relevant digital skills and prepare them for careers in emerging technologies.
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          Launched in India in 2022, the programme has successfully trained over 21,500 students across multiple states in Artificial Intelligence (AI), Coding &amp; Programming, Internet of Things (IoT), and Big Data. Globally, Samsung Innovation Campus is being implemented in over 35 countries, empowering thousands of youth with future-ready technology skills.
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          For SIC 2026, the programme has been designed with a special focus on Artificial Intelligence (AI) to prepare students for the rapidly evolving digital economy. The curriculum includes comprehensive training in:
        </Typography>
        <Bullets items={['Generative AI (Gen AI)', 'Core Artificial Intelligence (AI)']} />
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          The program combines conceptual learning with practical applications, enabling students to build industry-relevant skills through hands-on projects and real-world use cases.
        </Typography>

        <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
          Why Join Samsung Innovation Campus?
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Participants will benefit from:
        </Typography>
        <Bullets
          items={[
            'Industry-oriented training designed by Samsung.',
            'Comprehensive learning in Generative AI and Core AI.',
            'Hands-on practical sessions and project-based learning.',
            'Opportunity to learn from experienced industry trainers.',
            'Samsung Innovation Campus Certificate upon successful completion.',
            'Enhanced employability and future career opportunities in emerging technologies.',
            "Exposure to one of the world's leading technology companies through a nationally recognized CSR initiative.",
          ]}
        />

        <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
          Eligibility Criteria
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Applicants must satisfy the following eligibility requirements:
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          <strong>Age:</strong> 18–25 Years
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Eligible Courses:
        </Typography>
        <Bullets
          items={[
            'B.Tech: 2nd, 3rd & 4th Year Students',
            'BCA & B.Sc.: Second Year & Final Year Students',
            'MCA & M.Sc.: First Year & Final Year Students',
          ]}
        />

        <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
          Mode of Training
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          The program will be delivered through:
        </Typography>
        <Bullets items={['Offline Classroom Training', 'Hybrid Learning Model']} />
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          The training methodology includes instructor-led classroom sessions, practical exercises, assignments, assessments, and project-based learning.
        </Typography>

        <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
          Top Performer Recognition
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Samsung Innovation Campus 2026 will be implemented across 30 cities in India.
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          To recognize outstanding performance, one Top Performer from each participating city will be selected.
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          The selection process will be based on a comprehensive evaluation including, but not limited to:
        </Typography>
        <Bullets
          items={[
            'Technical Performance',
            'Post-Training Assessment Score',
            'Programme KPI Performance',
            'Attendance',
            'Classroom Participation',
            'Project Performance',
            'Discipline and Overall Conduct',
            'Any additional evaluation criteria as determined jointly by Samsung and ESSCI.',
          ]}
        />

        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          <strong>Please Note:</strong> Samsung and ESSCI reserve the right to modify the topper selection criteria, evaluation methodology, or recognition process at any stage of the programme without prior notice.
        </Typography>

        <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
          Important Information
        </Typography>
        <Bullets
          items={[
            'Registration does not guarantee admission to the programme.',
            'Admission is subject to eligibility verification and fulfilment of the programme selection process.',
            'Participants are expected to maintain regular attendance (min 90%) and actively participate in all training activities.',
            'Successful completion of all programme requirements is mandatory for certification.',
            'Samsung and ESSCI reserve the right to amend program guidelines, timelines, curriculum, assessment methodology, or operational processes as required.',
          ]}
        />

        <Typography variant="subtitle1">
          Note- In case of any query, feel free to reach out to ekansh@essc-india.org
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{ textTransform: 'none', minWidth: 80 }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
